export default "__VITE_ASSET__DquSVu3B__"